import classNames from 'classnames/bind';
import React from 'react';

import { BREAKPOINT_MD } from 'constants/breakpoints';
import useWindowWidth from 'hooks/use-window-width';
import Logo from 'images/shared/header/logo.inline.svg';

import styles from './footer.module.scss';

const cx = classNames.bind(styles);

const NAV_ITEMS = [
  {
    label: 'ABOUT',
    url: '#about',
  },
  {
    label: 'SUPPORTED STORES',
    url: '#stores',
  },
  {
    label: 'HOW IT WORKS',
    url: '#how-it-works',
  },
  {
    label: 'PRODUCTS',
    url: '#products',
  },
  {
    label: 'FAQ',
    url: '#faq',
  },
];

const Footer = () => {
  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert('Form has been submitted succesfully!');
  };

  const windowWidth = useWindowWidth();

  return (
    <footer className={cx('container', 'row', 'wrapper')} id="subscribe">
      {windowWidth > BREAKPOINT_MD && (
        <>
          <div className={cx('left')}>
            <a className={cx('logo')} href="/">
              <Logo />
            </a>
            <p className={cx('cta')}>subscribe to get our latest product updates:</p>
            <form className={cx('form')} onSubmit={handleFormSubmit}>
              <input type="email" placeholder="Enter your email..." required />
              <button type="submit">subscribe</button>
            </form>
            <p className={cx('credits')}>
              Creative design made by{' '}
              <a href="https://pixelpoint.io" target="_blank" rel="noreferrer">
                Pixel Point
              </a>
            </p>
            <div className={cx('illustration')} />
          </div>
          <div className={cx('right')}>
            <nav className={cx('nav')}>
              {NAV_ITEMS.map(({ label, url }, i) => (
                <a href={url} key={url}>
                  <span>{label}</span>
                </a>
              ))}
            </nav>
            <p className={cx('disclaimer')}>
              The product you are viewing is a piece of software designed to help increase your
              chances of purchasing limited edition sneakers and clothing from numerous sites listed
              on the home page. By purchasing Ghost AIO you are accepting the terms and conditions,
              and you also understand that this software does not guarantee your future purchases
              from the listed sites, but it does drastically increase your chances.
            </p>
          </div>
        </>
      )}
      {windowWidth <= BREAKPOINT_MD && (
        <>
          <div className={cx('illustration')} />
          <a className={cx('logo')} href="/">
            <Logo />
          </a>
          <nav className={cx('nav')}>
            {NAV_ITEMS.map(({ label, url }, i) => (
              <a href={url} key={url}>
                {label}
              </a>
            ))}
          </nav>
          <p className={cx('cta')}>subscribe to get our latest product updates:</p>
          <form className={cx('form')} onSubmit={handleFormSubmit}>
            <input type="email" placeholder="Enter your email..." required />
            <button type="submit">subscribe</button>
          </form>
          <p className={cx('disclaimer')}>
            The product you are viewing is a piece of software designed to help increase your
            chances of purchasing limited edition sneakers and clothing from numerous sites listed
            on the home page. By purchasing Ghost AIO you are accepting the terms and conditions,
            and you also understand that this software does not guarantee your future purchases from
            the listed sites, but it does drastically increase your chances.
          </p>
          <p className={cx('credits')}>
            Creative design made by <a href="https://pixelpoint.io">Pixel Point</a>
          </p>
        </>
      )}
    </footer>
  );
};

export default Footer;
